import '@babel/polyfill';
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import Vuelidate from 'vuelidate';
import VueClipboards from 'vue-clipboards';
import AuthorizService from '@/services/AuthorizService';
import AuctionsService from '@/services/AuctionsService';
import VueMoment from 'vue-moment';
import moment from 'moment-timezone';
import VueClipboard from 'vue-clipboard2';
import vuetify from './plugins/vuetify';
import 'material-design-icons-iconfont/dist/material-design-icons.css';

Vue.use(VueClipboard);
Vue.use(VueMoment, { moment });
Vue.use(VueClipboards);
Vue.use(Vuelidate);
AuthorizService.store = store;
AuctionsService.store = store;
Vue.config.productionTip = false;

new Vue({
  vuetify,
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
